import { LockClosedIcon } from "@heroicons/react/20/solid";
import { useLanguage } from "../../../contexts/LanguageContext";

const BADGES = {
  insights: { plan: "pricing.tier.growth.name", tone: "bg-indigo-50 text-indigo-700" },
  advanced: { plan: "pricing.tier.advanced.name", tone: "bg-orange-50 text-orange-800" },
};

// Overview / Insights / Advanced. Every tab is always offered; a locked one
// carries a lock and opens the sneak peek.
export default function DashboardTabs({ tabs, active, lockedTabs, onSelect }) {
  const { t } = useLanguage();

  return (
    <div
      role="tablist"
      aria-label={t("dashboard.tabs.label")}
      className="flex flex-wrap gap-x-1 border-b border-gray-200"
    >
      {tabs.map((tab) => {
        const selected = tab === active;
        const badge = BADGES[tab];
        const locked = lockedTabs.includes(tab);
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            id={`dashboard-tab-${tab}`}
            aria-selected={selected}
            aria-controls="dashboard-tabpanel"
            onClick={() => onSelect(tab)}
            className={`-mb-px inline-flex min-h-11 items-center gap-1.5 border-b-2 px-2.5 text-sm whitespace-nowrap sm:gap-2 sm:px-3.5 ${
              selected
                ? "border-indigo-600 font-semibold text-gray-900"
                : "border-transparent font-medium text-gray-600 hover:text-gray-900"
            }`}
          >
            {t(`dashboard.tabs.${tab}`)}
            {/* On a phone the plan badge would wrap the row; the lock alone says enough. */}
            {badge && locked && (
              <LockClosedIcon className="h-3.5 w-3.5 text-gray-500 sm:hidden" aria-hidden="true" />
            )}
            {badge && (
              <span className={`hidden items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold sm:inline-flex ${badge.tone}`}>
                {locked && <LockClosedIcon className="h-3 w-3" aria-hidden="true" />}
                {t(badge.plan)}
              </span>
            )}
            {locked && <span className="sr-only">{t("dashboard.tabs.locked")}</span>}
          </button>
        );
      })}
    </div>
  );
}
